import isNil from 'lodash/isNil'

export class HttpError extends Error {
  status?: number
  readyState?: number

  constructor(err: HttpError) {
    super(createErrorMessage(err))
    this.name = 'HttpError'
    // These propeties are using in filterAndNotify for bugsnag
    this.status = err?.status
    this.readyState = err?.readyState
  }
}

function createErrorMessage(err: HttpError & {responseText?: string}): string {
  return !isNil(err?.status) && !isNil(err?.responseText)
    ? `Unexpected HTTP error: ${err.status} - ${err.responseText}`
    : `Unexpected HTTP error`
}
